import React from 'react';
import { Box } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { Card, CardTitle } from '../../../../ui-kit';
import { DashboardRowWrapper, ItemsPerRow, ResponsiveColumnsContainer } from '../style';
import { useFromToContext } from '../../../shared';
import { useDateTimeService } from '../../../../utils/hooks/dateTimeService';
import LinkComponent from '../LinkComponent';
import TopProductCard from './TopProductCard';
import { TopProducts } from './types';

interface ProductsViewProps extends ItemsPerRow {
    products: TopProducts;
    title: string;
    linkUrl?: string;
}

const ProductsView: React.FC<ProductsViewProps> = ({ products, title, linkUrl, itemsPerRow }) => {
    const { dateFromTo } = useFromToContext();
    const { dateTimeService } = useDateTimeService();
    const history = useHistory();

    let searchParams: string | undefined;
    if (dateFromTo) {
        const from = dateTimeService.getDateTimeFromJsDate(dateFromTo.from).toISODate();
        const to = dateTimeService.getDateTimeFromJsDate(dateFromTo.to).toISODate();
        if (from && to) {
            searchParams = new URLSearchParams({
                from,
                to,
            }).toString();
        }
    }

    const referrer = `${history.location.pathname}${history.location.search}`;

    return (
        <Card fullHeight>
            <DashboardRowWrapper>
                <Box display='flex' alignItems='center'>
                    <CardTitle>{title}</CardTitle>
                    {linkUrl ? <LinkComponent search={searchParams} pathname={linkUrl} referrer={referrer} />: null}
                </Box>
                <ResponsiveColumnsContainer itemsPerRow={itemsPerRow}>
                    {products.map(product => (
                        <TopProductCard key={product.id} {...product} />
                    ))}
                </ResponsiveColumnsContainer>
            </DashboardRowWrapper>
        </Card>
    );
};

export default ProductsView;
